import { io } from "socket.io-client";

// Singleton Socket.IO client for the LMS. The server expects a `join` event
// keyed by the user's id (see backend/src/server.js — the user joins a room
// named after the id, and server-side fan-out emits use `io.to(String(id))`).
//
// Why a singleton: Chat.jsx and Chats.jsx historically each created their own
// io() client. The notification subscriber should reuse one connection so we
// don't churn three parallel sockets per tab on the chat surface. Until those
// pages are migrated, the notification flow uses this singleton and the chat
// pages keep their own — the doubled socket is harmless but wasteful.

const API_HOST = import.meta.env.VITE_HOST || "";

/** @type {import("socket.io-client").Socket | null} */
let socket = null;

export function getSocket() {
  if (socket) return socket;

  const token = localStorage.getItem("token");
  if (!token) return null;

  const userId = localStorage.getItem("userId");
  socket = io(API_HOST, {
    query: { token },
    transports: ["websocket"],
  });

  if (userId) {
    // server `socket.on("join", ...)` does `socket.join(userId)` — the room
    // name is whatever we pass here. Frontend stores the id as a string in
    // localStorage, so the server side `io.to(String(id))` lands here.
    socket.emit("join", userId);
  }

  return socket;
}

export function disconnectSocket() {
  if (!socket) return;
  socket.disconnect();
  socket = null;
}
